import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { helpTypographySx } from '../../constants/help-typography';

interface HelpI18nProviderProps {
  children: React.ReactNode;
}

/**
 * Applies help-specific typography only. RTL direction and Emotion cache are
 * owned by App.tsx (single source of truth) — do not add ThemeProvider or
 * CacheProvider here.
 */
const HelpI18nProvider: React.FC<HelpI18nProviderProps> = ({ children }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const onLanguageChanged = (lng: string) => setLanguage(lng);
    i18n.on('languageChanged', onLanguageChanged);
    return () => {
      i18n.off('languageChanged', onLanguageChanged);
    };
  }, [i18n]);

  return (
    <Box sx={{ width: '100%', ...helpTypographySx(language) }}>
      {children}
    </Box>
  );
};

export default HelpI18nProvider;
